<template>
  <div>
    <PayHead :mainTitle="pc_lang.checkout_counter"/>

    <div class="info main">
      <div class="wrapContent">
        <div class="order">
          <!-- 头部信息 -->
          <div class="title">
            <div>
              <p>{{pc_lang.order_number}}： <span>{{trade.mch_order_no}}</span></p>
              <span>{{trade.trade_notes}}</span>
            </div>
            <h5>{{trade.currency_short}} {{trade.amount}}</h5>
          </div>
          <!-- 订单详情 -->
          <transition name="blur">
            <table class="orderDesc" v-show="orderDescBool">
              <tbody>
                <!-- <tr>
                  <td>卖家昵称</td>
                  <td>嘻嘻嘻嘻嘻嘻嘻嘻</td>
                </tr> -->
                <tr>
                  <td>{{pc_lang.Order_time}}</td>
                  <td>{{trade.creation_time}}</td>
                </tr>
                <tr>
                  <td>{{pc_lang.Transaction_number}}</td>
                  <td>{{trade.trade_serial_no}}</td>
                </tr>
              </tbody>
            </table>
          </transition>
          <!-- 订单详情按钮 -->
          <div class="hr">
            <el-button type="info" size="mini" @click="orderDescBool = !orderDescBool">{{pc_lang.Order_details}}</el-button>
            <el-button type="danger" size="mini" @click="otherPayWayBool = 0" v-show="otherPayWayBool" class="backToBalance">{{pc_lang.Back_to_pay_with_balance}}</el-button>
          </div>
          <p class="billplzTips" v-show="otherPayWayBool">{{ `${pc_lang['BillplzTips']}` }}</p>
        </div>

        <div class="balance" v-show="!otherPayWayBool">
          <div>
            <p v-if="balanceList.length > 0">{{pc_lang.Credit_Balance}}</p>
            <div v-if="balanceList.length > 0">
              <SelectBox class="balanceItem" v-for="item in balanceList" :item="item" :key="item.currency" @click.native="handleItemClick(item)" />
            </div>
            <div class="noBalance" v-if="balanceList.length == 0">
              <router-link tag="span" :to="'/recharge?currency=All'">
                {{pc_lang.Your_account_has_no_balance_please_top_up_}}
              </router-link>；
              <span @click="otherPayWayBool = 1">{{pc_lang.Or_click_other_payment_methods_choose_Alipay_or_WeChat_pay}}</span>
            </div>
            <div class="PayIn" v-show="tradeRate != '' && tradeRate > -1">
              {{pc_lang.pending_to_be_pay}} <span>{{payForm.currency.currency_short}} {{tradeRate}}</span>
              <router-link tag="abbr" :to="'/recharge?currency=' + payForm.currency.currency_short" v-show="Number(tradeRate) > payForm.currency.amount">
                {{pc_lang.Your_xx_account_balance_is_insufficient_please_top_up.replace(/xx/, payForm.currency.currency_short)}}
              </router-link>
            </div>
            <div class="else">
              <router-link tag="span" :to="'/recharge?currency=All'">
                {{pc_lang.Topup_balance_select_new_currency}}
              </router-link>
              <span @click="otherPayWayBool = 1">{{pc_lang.Other_payment_methods}}</span>
            </div>
          </div>
          <!-- 支付密码 -->
          <div>
            <p>{{pc_lang.Payment_password}}</p>
            <div class="payWrap">
              <div class="form">
                <el-form :model="payForm" :rules="payRules" ref="payForm" label-width="0" class="payForm" @submit.native.prevent>
                  <el-form-item prop="payPassword">
                    <el-input type="password" v-model="payForm.payPassword" prefix-icon="el-icon-lock" autocomplete="off" :placeholder="pc_lang.Please_enter_the_payment_password" size="small" @keyup.enter.native="regForm('payForm')"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="forget">
                <router-link :to="`/user/resetPayPassword?tradeSerialNo=${$route.query.tradeSerialNo}`" tag="span" class="link">
                  {{pc_lang.Forget_password}}
                </router-link>
              </div>
            </div>

            <div class="submitWrap">
              <el-button type="primary" size="small" class="submit" @click="regForm('payForm')">{{pc_lang.Confirm_payment}}</el-button>
            </div>
          </div>
        </div>

        <RechargeWay :actCurrency="actCurrency" v-if="trade.currency_short && otherPayWayBool" />
      </div>
    </div>
    <!-- <form action="https://a5bmall.com" target="_self" ref="resultForm" id="resultForm" method="post" hidden> -->
    <form :action="payResult.return_url" target="_self" ref="resultForm" id="resultForm" method="post" hidden>
      <input type="text" v-for="(val, key) in payResult" :value="val" :name="key" v-if="key != 'return_url'">
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectBox from '@/components/ui/SelectBox'
import PayHead from '@/components/PayHead'
import RechargeWay from '@/components/rechargeWay/RechargeWay'
import both from '@/utils/storage'

import * as RegExp from '@/utils/RegExp'
import * as API_PAY from '@/api/pay'

export default {
  name: 'Pay',
  components:{
    SelectBox,
    RechargeWay,
    PayHead
  },
  data(){
    // 验证密码格式
    var validatePay = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Enter_the_password));
      } else if( !RegExp.payword.test(value) ) {
        callback(new Error(this.pc_lang.Password_consists_of_6_digits));
      }else {
        callback();
      }
    };

    return {
      // 是否显示详情
      orderDescBool: 0,

      // 余额列表
      balanceList: [],

      // 余额转换汇率值
      tradeRate: '-1',

      // 支付信息
      trade: {},

      // 支付密码
      payForm: {
        payPassword: '',
        tradeSerialNo: this.$route.query.tradeSerialNo,
        currency: '',
        currencyShort: ''
      },
      payRules: {
        payPassword: [
          { validator: validatePay, trigger: 'blur' }
        ]
      },
      /* 支付成功结果 */
      payResult: {},
      /* 其他付款方式 */
      otherPayWayBool: 0
    }
  },
  computed: {
    ...mapGetters(['currencyList', 'user']),
    /* 是否有选中的币种 */
    actCurrency() {
      let item = this.currencyList.filter(obj=> {
        return obj.currency_short == this.trade.currency_short
      })[0]
      return item == undefined ? '' : item
    }
  },
  async mounted() {

  },
  created() {
    if (!!this.user.pay_password) {
      this.payInfo()
    } else {
      this.$router.push({name: 'InitPayPassword', query: {forward: this.$route.fullPath}})
    }
  },
  methods: {
    /* 重置表单 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        }else{
          return false
        }
      })
    },
    /* 选择币种 */
    handleItemClick(item) {
      this.payTradeRate(item.currency_short).then(()=>{
        this.balanceList.forEach(obj=> obj.act = 0)
        item.act = 1
        this.payForm.currency = item
        this.payForm.currencyShort = item.currency_short
      })
    },
    /* 请求支付详情 */
    payInfo() {
      API_PAY.payInfo({ tradeSerialNo: this.$route.query.tradeSerialNo  }).then(res=> {
        this.balanceList = res.data.amounts.map((obj, i)=>{
          this.$set(obj, 'act', 0)
          return obj
        })
        let tradeItem = res.data.trade
        tradeItem.creation_time = both.getChinaTime( tradeItem.creation_time * 1000 )
        this.trade = res.data.trade

        // 选中第一个余额
        this.$nextTick(()=> {
          if (this.balanceList.length) {
            this.handleItemClick(this.balanceList[0])
          }
        })

        // 设置回调网页
        both.storage.set('authBackUrl', res.data.source)
      },rej=> {
        this.$messageBox.alert(rej.msg, this.pc_lang.Payment_failed, {
          type: 'error',
          callback: ()=> {
            this.$router.push({ name: 'Transactions' })
          }
        })
      })
    },
    /* 转换币种金额 */
    payTradeRate(currencyShort) {
      return new Promise((resolve, reject)=> {
        API_PAY.payTradeRate({ tradeSerialNo: this.$route.query.tradeSerialNo , currencyShort }).then(res=> {
          this.tradeRate = res.data
          resolve(res)
        },rej=> {
          reject(rej)
        })
      })
    },
    /* 提交支付 */
    submit(currencyShort) {
      new Promise((resolve, reject)=> {
        let params = this.payForm
        params["amount"] = this.trade.amount
        if (params.currency == '') {
          this.$messageBox.alert(this.pc_lang.Please_select_a_payment_currency, this.pc_lang.Payment_failed, {
            type: 'error'
          })
          return false
        }
        if (this.tradeRate > Number(params.currency.amount)) {
          this.$messageBox.alert(this.pc_lang.Account_balance_is_insufficient_please_top_up, this.pc_lang.Payment_failed, {
            type: 'error'
          })
          return false
        }
        params.payPassword = md5(params.payPassword)
        API_PAY.paymentPay(params).then(res=> {
          this.payResult = res.data
          /* 提交结果的表单 */
          setTimeout(()=>{
            this.$refs.resultForm.submit()
          },100)
          resolve(res)
        },rej=> {
          this.$messageBox.alert(rej.msg, this.pc_lang.Payment_failed, {
            type: 'error',
            callback: ()=> {
              this.payForm.payPassword = ''
            }
          })
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.info{
  margin: 40px 0;
  .wrapContent{
    background: #fff;
    padding: 30px 55px;
    @extend .shadow;
    .order{

      .title{
        display: flex;
        align-items: center;
        >div{
          max-width: 800px;
          >p{
            font-size: 16px;
            margin-bottom: 6px;
            span{
              font-size: 18px;
              color: $red_xi;
            }
          }
          >span{
            color: #777;
          }
        }
        >h5{
          flex: 1;
          font-size: 24px;
          color: $red_xi;
          text-align: right;
        }
      }

      .orderDesc{
        margin-top: 20px;
        width: 800px;
        color: #777;
        tr{
          display: table-row-group;
          td{
            padding: 5px 5px 5px 0;
            &:first-child{
              text-align: right;
              &:after{
                content: '：';
                margin: 0 3px 0 6px;
              }
            }
          }
        }
      }

      .hr{
        padding-top: 20px;
        border-bottom: 2px solid #eee;
        text-align: right;
        position: relative;
        button{
          margin-right: 30px;
        }
        .backToBalance{
          position: absolute;
          left: 20px;
          bottom: 0;
        }
      }

      .billplzTips{
        color: #f00;
        margin-top: 12px;
      }
    }

    .balance{
      .noBalance{
        margin-top: 16px;
        color: #f00;
        padding: 10px 0;
        >span{
          @extend .transition;
          &:hover{
            color: $blue;
            cursor: pointer;
            @extend .transition;
          }
        }
      }
      >div{
        >p{
          display: inline-block;
          margin: 16px 0;
          color: #666;
          &:after{
            content: '：';
            margin-left: 3px;
          }
        }
        .PayIn{
          margin: 14px 0 30px;
          color: #999;
          span{
            color: #f00;
            font-weight: 600;
          }
          abbr{
            margin-left: 30px;
            text-shadow: 0px 0px 1px #d0e239;
            color: #f00;
            &:hover{
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
        .else{
          margin-top: 16px;
          span{
            display: inline-block;
            padding: 6px 16px;
            border: $border;
            margin-right: 10px;
            color: $blue;
            font-size: 12px;
            @extend .transition;
            &:hover{
              color: $red_xi;
              border-color: $red_xi;
              cursor: pointer;
              @extend .transition;
            }
            &:last-child{
              border-style: dashed;
            }
          }
        }
        >div.payWrap{
          display: flex;
          align-items: center;
          .form{
            width: 200px;
            margin-right: 20px;
          }
          .forget{
            color: $blue;
            span{
              cursor: pointer;
            }
          }
        }
      }
      .submitWrap{
        margin-top: 24px;
        .submit{
          padding: 9px 20px;
        }
      }
      .balanceItem{
        margin: 0 10px 10px 0;
      }
    }
  }
}
</style>
